import { Flex, Text } from '@mantine/core';
import {
  BORDER_COLOR,
  CELL_PADDING,
  FONT_SIZE,
  HEADER_BG,
  LINE_HEIGHT,
  TEXT_COLOR,
  LEFT_SECTION_WIDTH,
  INDENT_SIZE,
  useTableStyles,
  TEXT_COLOR_SECONDARY
} from '../tableConstants';
import { TbChevronDown, TbChevronUp } from 'react-icons/tb';
import { idCreator } from '../../../../../Project/utils/idCreator';

export const MultiFundHeaderRow = ({
  id,
  number,
  name,
  fundKeys = [],
  funds,
  isOpen = true,
  onToggle
}) => {
  const columnWidth = `${100 / Math.max(fundKeys.length, 1)}%`;

  const { classes } = useTableStyles();
  const rowId = id || `formpf-multi-fund-header-${idCreator(`${number}-${name}`)}`;

  return (
    <Flex id={rowId} miw="min-content" className={classes.borderBottom}>
      <Flex
        id={`${rowId}-left-sticky`}
        classNames={{
          root: `${classes.leftSticky} ${classes.borderRight}`
        }}
        maw={LEFT_SECTION_WIDTH}
        miw={LEFT_SECTION_WIDTH}
      >
        <Flex
          className={classes.borderRight}
          p={CELL_PADDING}
          bg={HEADER_BG}
          c={TEXT_COLOR_SECONDARY}
          fz={FONT_SIZE}
          lh={LINE_HEIGHT}
          miw={INDENT_SIZE}
          maw={INDENT_SIZE}
          fw={600}
          align="center"
          justify="center"
        >
          {number}
        </Flex>
        <Flex
          id={`formpf-multi-fund-header-toggle-${idCreator(`${number}-${name}`)}`}
          component="button"
          onClick={onToggle}
          align="center"
          gap="8px"
          flex="auto"
          p={CELL_PADDING}
          bg={HEADER_BG}
        >
          <Text
            id={`formpf-multi-fund-header-name-${idCreator(`${number}-${name}`)}`}
            fw={600}
            c={TEXT_COLOR_SECONDARY}
            fz={FONT_SIZE}
            lh={LINE_HEIGHT}
          >
            {name}
          </Text>

          {isOpen ? (
            <TbChevronUp color={TEXT_COLOR_SECONDARY} size={16} />
          ) : (
            <TbChevronDown color={TEXT_COLOR_SECONDARY} size={16} />
          )}
        </Flex>
      </Flex>
      <Flex flex="auto">
        {fundKeys.map((fundKey, index) => (
          <Text
            id={`${rowId}-fund-${fundKey}`}
            key={fundKey}
            p={CELL_PADDING}
            bg={HEADER_BG}
            miw={
              fundKeys.length > 3 && window.innerWidth < fundKeys.length * 260 + LEFT_SECTION_WIDTH
                ? '260px'
                : columnWidth
            }
            maw={
              fundKeys.length > 3 && window.innerWidth < fundKeys.length * 260 + LEFT_SECTION_WIDTH
                ? '260px'
                : columnWidth
            }
            c={TEXT_COLOR}
            fz={FONT_SIZE}
            lh={LINE_HEIGHT}
            sx={() => ({
              borderRight: index === fundKeys.length - 1 ? 'none' : `1px solid ${BORDER_COLOR}`
            })}
            ta="center"
          >
            {funds?.[fundKey]?.fund_name && (
              <span id={`formpf-multi-fund-header-fund-name-${idCreator(`${rowId}-${fundKey}`)}`}>
                {funds?.[fundKey]?.fund_name}
              </span>
            )}
          </Text>
        ))}
      </Flex>
    </Flex>
  );
};
